import { render, staticRenderFns } from "./ServiceListItem.vue?vue&type=template&id=779166df&scoped=true&"
import script from "./ServiceListItem.vue?vue&type=script&lang=js&"
export * from "./ServiceListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779166df",
  null
  
)

export default component.exports